import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  "class": "mt-3"
};
var _hoisted_2 = {
  "class": "row justify-content-center"
};
var _hoisted_3 = {
  "class": "card card-profile shadow w-100"
};
var _hoisted_4 = {
  "class": "row justify-content-center"
};
var _hoisted_5 = {
  "class": "col-lg-3 order-lg-2"
};
var _hoisted_6 = {
  "class": "card-profile-image-sm"
};
var _hoisted_7 = {
  href: "#"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  "class": "card-header text-center border-0 pt-md-4 pb-0 pb-md-4"
};
var _hoisted_10 = {
  key: 0,
  "class": "d-flex justify-content-between"
};
var _hoisted_11 = {
  "class": "card-body pt-4 pt-md-4"
};
var _hoisted_12 = {
  "class": "text-center"
};
var _hoisted_13 = {
  "class": "row"
};
var _hoisted_14 = {
  "class": "col"
};
var _hoisted_15 = {
  "class": "card-profile-stats d-flex justify-content-center mt-md-0"
};
var _hoisted_16 = {
  "class": "heading"
};

var _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  "class": "description"
}, "Followers", -1);

var _hoisted_18 = {
  "class": "heading"
};

var _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  "class": "description"
}, "Posts", -1);

var _hoisted_20 = {
  "class": "heading"
};

var _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  "class": "description"
}, "Following", -1);

var _hoisted_22 = {
  "class": "text-center"
};
var _hoisted_23 = {
  "class": "card-profile-stats d-flex justify-content-center mt-md-0"
};
var _hoisted_24 = {
  "class": "h5 font-weight-300"
};

var _hoisted_25 = /*#__PURE__*/_createElementVNode("i", {
  "class": "ni location_pin mr-2"
}, null, -1);

var _hoisted_26 = {
  key: 0,
  "class": "h5 font-weight-300"
};

var _hoisted_27 = /*#__PURE__*/_createElementVNode("i", {
  "class": "fa-solid fa-users"
}, null, -1);

var _hoisted_28 = {
  "class": "container-fluid mt-2"
};
var _hoisted_29 = {
  "class": "row"
};
var _hoisted_30 = {
  "class": "row"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;

  var _component_base_button = _resolveComponent("base-button");

  var _component_el_progress = _resolveComponent("el-progress");

  var _component_base_header = _resolveComponent("base-header");

  var _component_post_card = _resolveComponent("post-card");

  var _component_vue_loadmore = _resolveComponent("vue-loadmore");

  var _component_el_tab_pane = _resolveComponent("el-tab-pane");

  var _component_el_tabs = _resolveComponent("el-tabs");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_base_header, {
    type: "gradient-success",
    "class": "pb-4 pb-4 pt-5 pt-md-5"
  }, {
    "default": _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("a", _hoisted_7, [_createElementVNode("img", {
        src: $data.headImg,
        "class": "rounded-circle"
      }, null, 8, _hoisted_8)])])])]), _createElementVNode("div", _hoisted_9, [!$data.isSelf ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_base_button, {
        size: "sm",
        type: "info",
        "class": "mr-4",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $options.follow(!_this.isFollowed);
        })
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t($data.isFollowed ? "button.followed" : "button.follow")), 1)];
        }),
        _: 1
      }), _createVNode(_component_base_button, {
        size: "sm",
        type: "default",
        "class": "float-right",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $options.mute(!_this.isMuted);
        })
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t($data.isMuted ? "button.muted" : "button.mute")), 1)];
        }),
        _: 1
      })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString($data.about), 1), _createVNode(_component_el_progress, {
        "text-inside": true,
        "stroke-width": 18,
        percentage: $data.votingPower / 100,
        status: "success"
      }, null, 8, ["percentage"]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_16, _toDisplayString($data.followers.length), 1), _hoisted_17]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_18, _toDisplayString($data.postCount), 1), _hoisted_19]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_20, _toDisplayString($data.following.length), 1), _hoisted_21])])])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("h3", null, _toDisplayString($data.userName), 1), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createTextVNode(_toDisplayString($data.location), 1)]), _ctx.likeid ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_hoisted_27, _createTextVNode(" LikeId: " + _toDisplayString(_ctx.likeid), 1)])) : _createCommentVNode("", true)])])])])])])];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_tabs, {
    modelValue: $data.editableTabsValue,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.editableTabsValue = $event;
    }),
    type: "card",
    "class": "tabs"
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.editableTabs, function (item, index) {
        return _openBlock(), _createBlock(_component_el_tab_pane, {
          key: item.name,
          label: item.title,
          name: item.name,
          closable: index > 1
        }, {
          "default": _withCtx(function () {
            return [index == 0 ? (_openBlock(), _createBlock(_component_vue_loadmore, {
              key: 0,
              "on-refresh": $options.onRefreshBlogs,
              "on-loadmore": $options.onLoadBlogs,
              finished: _ctx.finishedBlogs,
              "load-offset": 200
            }, {
              "default": _withCtx(function () {
                return [_createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.blogs, function (item) {
                  return _openBlock(), _createBlock(_component_post_card, {
                    key: item.id,
                    blogs: item,
                    "class": "pb-2 pb-2 pt-1 pt-md-1"
                  }, null, 8, ["blogs"]);
                }), 128))])];
              }),
              _: 2
            }, 1032, ["on-refresh", "on-loadmore", "finished"])) : index == 1 ? (_openBlock(), _createBlock(_component_vue_loadmore, {
              key: 1,
              "on-refresh": $options.onRefreshPosts,
              "on-loadmore": $options.onLoadPosts,
              finished: _ctx.finishedPosts,
              "load-offset": 200
            }, {
              "default": _withCtx(function () {
                return [_createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.posts, function (item) {
                  return _openBlock(), _createBlock(_component_post_card, {
                    key: item.id,
                    blogs: item,
                    "class": "pb-2 pb-2 pt-1 pt-md-1"
                  }, null, 8, ["blogs"]);
                }), 128))])];
              }),
              _: 2
            }, 1032, ["on-refresh", "on-loadmore", "finished"])) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1032, ["label", "name", "closable"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["modelValue"])])], 64);
}